import { Pipe, PipeTransform } from '@angular/core';

import { BoardColumn } from '@main-application/boards/interfaces/board';

@Pipe({
  name: 'columnName',
})
export class ColumnNamePipe implements PipeTransform {
  transform(columnId: string, columns: BoardColumn[] = []): string {
    return columns?.find(c => c.id === columnId)?.name ?? 'Unknown column';
  }
}
